import { render, staticRenderFns } from "./Colourshift.vue?vue&type=template&id=634c422a&"
import script from "./Colourshift.vue?vue&type=script&lang=js&"
export * from "./Colourshift.vue?vue&type=script&lang=js&"
import style0 from "./Colourshift.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports